// extracted by mini-css-extract-plugin
export var hideEditor = "_nl-2";
export var infoIcon = "_nl-3";
export var label = "_nl-1";
export var labelContainer = "_nl-0";
export var readonlyText = "_nl-4";